import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
    data:{}
   
    
}
const mutations={


    getRolesIndex(){
        
        
     
        post(urls.admin.roles.index,{}).then((result)=>{

          state.data=result
         
          
          
       
        
       
           
        });
        
    },
    addRolesData(state,value){
        
        
     
        post(urls.admin.roles.add,value).then((result)=>{
         
         
          state.result=result
         
        });
        
    },
    editRolesData(state,value){

        post(urls.admin.roles.edit,value).then((result)=>{


            state.result=result

        });

    },
    deleteRolesData(state,value){

        post(urls.admin.roles.delete,value).then((result)=>{


            state.result=result

        });

    },

}
const  actions={
    getRolesIndexAction(context,value){
       
        context.commit("getRolesIndex",value)
       
    },
    addRolesDataAction(context,value){
       
        context.commit("addRolesData",value)
       
    },
    editRolesDataAction(context,value){

        context.commit("editRolesData",value)

    },
    deleteRolesDataAction(context,value){

        context.commit("deleteRolesData",value)

    },

  
    
   

}

export default {state,mutations,actions}